export enum PageTypes {
  Portal = 'Portal',
  Public = 'Public'
}

export enum LoggedInStatus {
  LoggedIn = "Logged In",
  LoggedOut = "Logged Out"
}

export enum RegisterMethod {
  Email = "Email",
  Google = "Google",
  Apple = "Apple"
}

export enum Adjust_payment_plan {
  RateAmount = "Rate Amount",
  PaymentDate = "Payment Date",
  PaymentMethod = "Payment Method"
}

export enum Plan_update_type {
  PaymentMethodUpdate = "Payment method update",
  DateUpdate = "Date update",
  AmountUpdate = "Amount update"
}

